import { IInitialCatalogCsvUploadState } from 'interfaces/catalogCsvUpload.interface';

const initialcatalogCsvUploadState: IInitialCatalogCsvUploadState = {
  // Reports by upload
  getReportsByUpload: () => {},
  reportsByUpload: [],
  isLoadingByUpload: false,
  // Reports by season
  getReportsBySeason: () => {},
  reportsBySeason: [],
  isLoadingBySeason: false,
  // Publish upload
  publishUpload: () => {},
  isLoadingPublishUpload: {
    isLoading: false,
    uploadId: '',
  },
  // Reject upload
  rejectUpload: () => Promise.resolve(false),
  isLoadingRejectUpload: {
    isLoading: false,
    uploadId: '',
  },
  // Season
  setStartSeasonDate: () => {},
  setEndSeasonDate: () => {},
  enableSeason: () => {},
  isLoadingEnableSeason: {
    isLoading: false,
    seasonId: '',
  },
};

export default initialcatalogCsvUploadState;
